module.exports = __webpack_public_path__ + "static/media/bg2.c5c8a54d.jpeg";